<script lang="ts" setup>
import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'
import { useUserStore } from '@/store/user/user'

const { isAuthenticated } = storeToRefs(useUserStore())
const { showDialog } = useDialogsStore()

const isLoading = ref(true)

const title = computed(() => (isAuthenticated.value ? '' : 'Войти'))

const width = computed(() => {
  return isLoading.value || !isAuthenticated.value ? 134 : 40
})

const onProfileClick = () => {
  if (isAuthenticated.value) {
    return navigateTo('/profile/orders/')
  }

  showDialog(DIALOGS.LOGIN)
}

onMounted(() => (isLoading.value = false))
</script>

<template>
  <the-button
    variant="tertiary"
    size="xxs"
    font="lg"
    radius="lg"
    icon="fill-user"
    :width="width"
    height="40"
    :loading="isLoading"
    @click="onProfileClick"
  >
    <client-only>
      {{ title }}
    </client-only>
  </the-button>
</template>
